import { en } from '../default-messages';
import { intlCookies } from '../types';

export function getDefaultTranslations(): {
  locale: string;
  messages: Record<string, string>;
} {
  const persistedLanguage = window.localStorage.getItem(intlCookies.LOCALE);
  const persistedMessages = window.localStorage.getItem(intlCookies.MESSAGES);

  if (persistedLanguage && persistedMessages) {
    return {
      locale: persistedLanguage,
      messages: { ...en, ...JSON.parse(persistedMessages) },
    };
  }

  return {
    locale: 'en',
    messages: en,
  };
}
